var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddtasksPana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 33.9,
    y: 34.08,
    width: 96.05,
    height: 85.93,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,120s0-.55,0-1.6,0-2.59,0-4.6c0-4,0-9.93-.06-17.44,0-15-.06-36.47-.11-62.3l.22.22-96,0h0l.25-.26c0,31.27,0,60.69,0,85.94l-.22-.23,69.47.12L123,120l5.19,0,1.34,0H128.2l-5.14,0-19.55.06-69.61.11h-.23V120c0-25.25,0-54.67,0-85.94v-.25h.27l96,0h.22v.21c0,25.88-.09,47.39-.11,62.43,0,7.49-.05,13.37-.06,17.4,0,2,0,3.52,0,4.56S130,120,130,120Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.73,49.35c0,.15-5.06.26-11.29.26s-11.3-.11-11.3-.26,5.06-.25,11.3-.25S70.73,49.21,70.73,49.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.43,55.81c0,.14-13.89.25-31,.25s-31-.11-31-.25,13.88-.26,31-.26S111.43,55.66,111.43,55.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.31,
    y: 66.74,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.27,
    y: 66.74,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.42,
    y: 66.55,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.19,
    y: 66.74,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.15,
    y: 66.74,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.12,
    y: 66.74,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.08,
    y: 66.74,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.31,
    y: 75.34,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.27,
    y: 75.34,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.23,
    y: 75.34,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.19,
    y: 75.34,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.15,
    y: 75.34,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.3,
    y: 75.15,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.08,
    y: 75.34,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.31,
    y: 83.94,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.46,
    y: 83.76,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.23,
    y: 83.94,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.19,
    y: 83.94,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.15,
    y: 83.94,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.12,
    y: 83.94,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.08,
    y: 83.94,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.31,
    y: 92.54,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.27,
    y: 92.54,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.23,
    y: 92.54,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.38,
    y: 92.36,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.15,
    y: 92.54,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.12,
    y: 92.54,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.08,
    y: 92.54,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.31,
    y: 101.15,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.27,
    y: 101.15,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.23,
    y: 101.15,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.19,
    y: 101.15,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.15,
    y: 101.15,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.3,
    y: 100.96,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.08,
    y: 101.15,
    width: 4.05,
    height: 4.05,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.46,
    y: 35.83,
    width: 68.04,
    height: 68.04,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5,103.88s0-.12,0-.33,0-.54,0-1c0-.84,0-2.07,0-3.66,0-3.22,0-7.9-.06-13.85,0-11.91-.07-28.89-.12-49.26l.23.23-68,0h0l.26-.26c0,24.92,0,48.27,0,68.05l-.22-.23,49.25.12,13.85.06,3.67,0h.94l.33,0h-1.22l-3.63,0-13.79.06-49.4.11h-.23v-.22c0-19.78,0-43.13,0-68v-.26h.26l68,0h.23v.22c-.05,20.43-.09,37.46-.12,49.4,0,5.93,0,10.6-.06,13.8,0,1.58,0,2.79,0,3.62,0,.4,0,.7,0,.92S470.5,103.88,470.5,103.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.21,53.25c0,.14-15.17.26-33.88.26s-33.87-.12-33.87-.26S417.62,53,436.33,53,470.21,53.11,470.21,53.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 409.08,
    cy: 44.19,
    r: 1.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 414.96,
    cy: 44.19,
    r: 1.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.77,44.19a1.93,1.93,0,1,1-1.93-1.93A1.92,1.92,0,0,1,422.77,44.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 416.24,
    cy: 67.73,
    r: 5.53,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.77,88a5.53,5.53,0,1,1-5.53-5.53A5.53,5.53,0,0,1,421.77,88Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.34,67.28c0,.14-7.56.26-16.89.26s-16.89-.12-16.89-.26,7.56-.26,16.89-.26S460.34,67.13,460.34,67.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.73,87.93a69.48,69.48,0,0,1-12,0,69.48,69.48,0,0,1,12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.34,
    cy: 92.77,
    r: 21.45,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.36,
    y: 84.63,
    width: 2,
    height: 15.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.4,
    y: 91.59,
    width: 15.92,
    height: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.34,
    cy: 253.31,
    r: 21.45,
    transform: "translate(-94.68 40.05) rotate(-22.94)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.35,
    y: 245.18,
    width: 2,
    height: 15.92,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.39,
    y: 252.14,
    width: 15.92,
    height: 2,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.74,
    y: 348.53,
    width: 145.68,
    height: 67.18,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,412.55H169.07V352.06H308Zm-138-.91H307V353H170Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.42,
    y: 348.53,
    width: 35.59,
    height: 67.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.53,370.78h138a.18.18,0,0,0,0-.36h-138a.18.18,0,1,0,0,.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,370.6a150.16,150.16,0,0,0,0-18.25.19.19,0,0,0-.37,0,152.22,152.22,0,0,0,0,18.25.14.14,0,0,0,.28,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.1,361.47a1.88,1.88,0,1,1-1.88-1.88A1.88,1.88,0,0,1,276.1,361.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.69,361.47a1.88,1.88,0,1,1-1.88-1.88A1.88,1.88,0,0,1,203.69,361.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.39,382.31a1.88,1.88,0,1,1-1.88-1.88A1.88,1.88,0,0,1,240.39,382.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.16 415.71 175.66 457.89 179.88 457.89 193.7 415.71 183.16 415.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.11 415.71 307.38 457.96 303.16 457.96 290.56 415.71 301.11 415.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.27 415.71 336.38 457.96 332.16 457.96 318.72 415.71 329.27 415.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.26,401.32a1.88,1.88,0,1,1-1.87-1.88A1.88,1.88,0,0,1,240.26,401.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.53,391.59h138a.19.19,0,0,0,0-.37h-138a.19.19,0,0,0,0,.37Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M461.43,458.08c0,.14-97.8.26-218.42.26s-218.44-.12-218.44-.26,97.78-.26,218.44-.26S461.43,457.93,461.43,458.08Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.46,
    y: 68.72,
    width: 299.89,
    height: 264.22,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.46,
    y: 229.59,
    width: 299.89,
    height: 44.64,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.46,
    y: 178.52,
    width: 299.89,
    height: 51.08,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.46,
    y: 281.53,
    width: 299.89,
    height: 51.08,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.53,194.42c0,.15-35.37.27-79,.27s-79-.12-79-.27,35.36-.26,79-.26S267.53,194.28,267.53,194.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.24,208.64c0,.14-15,.26-33.57.26s-33.57-.12-33.57-.26,15-.26,33.57-.26S176.24,208.5,176.24,208.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.53,244.81c0,.14-35.37.26-79,.26s-79-.12-79-.26,35.36-.26,79-.26S267.53,244.66,267.53,244.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.24,259c0,.15-15,.26-33.57.26s-33.57-.11-33.57-.26,15-.26,33.57-.26S176.24,258.88,176.24,259Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.53,295.19c0,.14-35.37.26-79,.26s-79-.12-79-.26,35.36-.26,79-.26S267.53,295,267.53,295.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.24,309.4c0,.15-15,.26-33.57.26s-33.57-.11-33.57-.26,15-.26,33.57-.26S176.24,309.26,176.24,309.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.46,
    y: 68.39,
    width: 299.89,
    height: 25.21,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.46,
    y: 91.21,
    width: 299.89,
    height: 25.21,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.51,80.2A3.17,3.17,0,1,1,101.35,77,3.16,3.16,0,0,1,104.51,80.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.13,80.2A3.17,3.17,0,1,1,113,77,3.17,3.17,0,0,1,116.13,80.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.74,80.2A3.17,3.17,0,1,1,124.57,77,3.17,3.17,0,0,1,127.74,80.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.41,333c0-1.68-.06-103-.15-264.56l.15.2-299.74.06h0l.18-.26c0,93.91,0,183.35,0,264.56l-.17-.24,299.76.24-299.76.24h-.18V333c0-81.21,0-170.65,0-264.56v-.26h.21l299.74.05h.15v.21C386.46,230,386.41,331.27,386.41,333Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.79,
    y: 131.28,
    width: 82.52,
    height: 27.91,
    rx: 5.77,
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,145.08h-1.79v1.77h-.83v-1.77h-1.8v-.78h1.8v-1.78h.83v1.78H290Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.81,146.41h-3.68l-.76,1.73h-1l3.13-6.91h1l3.14,6.91h-1Zm-.35-.79L297,142.23l-1.49,3.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.38,140.81v7.33h-.91v-.83a2.2,2.2,0,0,1-1.86.89,2.67,2.67,0,0,1,0-5.34,2.19,2.19,0,0,1,1.82.84v-2.89Zm-.94,4.71a1.76,1.76,0,1,0-1.75,1.85A1.72,1.72,0,0,0,305.44,145.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.12,140.81v7.33h-.91v-.83a2.23,2.23,0,0,1-1.87.89,2.67,2.67,0,0,1,0-5.34,2.22,2.22,0,0,1,1.83.84v-2.89Zm-.94,4.71a1.77,1.77,0,1,0-3.53,0,1.77,1.77,0,1,0,3.53,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.09,142.09h-2.37v-.86h5.71v.86h-2.37v6h-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.24,145v3.16h-.89v-.69a2,2,0,0,1-1.72.75c-1.19,0-1.94-.63-1.94-1.54s.54-1.53,2.11-1.53h1.5v-.19c0-.8-.47-1.26-1.41-1.26a2.64,2.64,0,0,0-1.66.56l-.39-.71a3.44,3.44,0,0,1,2.16-.67C326.43,142.86,327.24,143.55,327.24,145Zm-.94,1.56v-.73h-1.47c-.93,0-1.2.36-1.2.81s.44.85,1.16.85A1.52,1.52,0,0,0,326.3,146.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.34,147.59l.4-.75a3.38,3.38,0,0,0,1.83.54c.88,0,1.25-.27,1.25-.71,0-1.18-3.31-.16-3.31-2.24,0-.94.84-1.57,2.18-1.57a3.8,3.8,0,0,1,1.91.47l-.41.75a2.69,2.69,0,0,0-1.51-.41c-.83,0-1.23.3-1.23.72,0,1.23,3.32.22,3.32,2.26,0,.95-.87,1.55-2.27,1.55A3.85,3.85,0,0,1,328.34,147.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,145.7l-1.09,1v1.43H334v-7.33h.95v4.7l2.85-2.6h1.15l-2.2,2.16,2.42,3.07H338Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.56,142.87h-3v-1.76h8.14v1.76h-3v7.58h-2.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.55,148.45h-4.34l-.82,2h-2.22l4.16-9.34h2.14l4.17,9.34h-2.26Zm-.68-1.64-1.48-3.58-1.48,3.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.88,149.53l.74-1.63a5.5,5.5,0,0,0,3.08,1c1.28,0,1.8-.43,1.8-1,0-1.74-5.43-.54-5.43-4,0-1.59,1.28-2.91,3.93-2.91a6.2,6.2,0,0,1,3.24.83l-.66,1.64a5.31,5.31,0,0,0-2.59-.73c-1.28,0-1.77.48-1.77,1.06,0,1.72,5.42.54,5.42,4,0,1.56-1.29,2.9-4,2.9A6.66,6.66,0,0,1,134.88,149.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.52,146.78l-1.25,1.31v2.36h-2.15v-9.34h2.15v4.36l4.14-4.36h2.4l-3.87,4.16,4.09,5.18h-2.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.06,149.53l.73-1.63a5.53,5.53,0,0,0,3.08,1c1.28,0,1.8-.43,1.8-1,0-1.74-5.42-.54-5.42-4,0-1.59,1.28-2.91,3.93-2.91a6.25,6.25,0,0,1,3.24.83l-.67,1.64a5.28,5.28,0,0,0-2.58-.73c-1.28,0-1.78.48-1.78,1.06,0,1.72,5.43.54,5.43,4,0,1.56-1.29,2.9-4,2.9A6.64,6.64,0,0,1,153.06,149.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.35,
    y: 198.09,
    width: 61.51,
    height: 17.71,
    rx: 8.85,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,266.93H316.2a8.85,8.85,0,0,1-8.85-8.85h0a8.85,8.85,0,0,1,8.85-8.85H360a8.85,8.85,0,0,1,8.85,8.85h0A8.85,8.85,0,0,1,360,266.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.35,
    y: 299.32,
    width: 61.51,
    height: 17.71,
    rx: 8.85,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79,385.16c-8,2.81-18.54.3-25.42-4.73s-11.83-12.22-16.21-19.52c-1.88-3.12-3.7-6.36-4.3-10s.28-7.62,3.06-10c4.33-3.64,11-1.8,15.86,1a54.72,54.72,0,0,1,27,43.16",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.35,404.41c-4.83,6.37-13.13,9.21-21.11,9.58s-15.88-1.84-23.35-4.71c-2.71-1-5.67-2.46-6.6-5.21a6.63,6.63,0,0,1,1.42-6.15,13.81,13.81,0,0,1,5.39-3.67c7.34-3.13,15.76-3.28,23.49-1.27s14.49,6.48,20.76,11.43",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1,350.7c-6.65.14-11.69-5.69-14.71-11.63a43.18,43.18,0,0,1-4-26.89c.61-3.41,1.89-7.07,4.94-8.71s7.12-.57,9.71,1.8,4,5.75,5,9.1c3.58,11.57,2.81,24.86-1,36.33",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,387.53c-11.35-19.32-13.24-43-6.54-64.34,1.09-3.46,3.14-7.43,6.77-7.66,4-.26,6.54,4.22,7.65,8.09,3.89,13.58,3.06,28,2.2,42.09-.53,8.69-3.51,16.11-10.08,21.82",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.78,395.47a46.41,46.41,0,0,1,27.54-29.21c3-1.13,6.85-1.78,9.09.53s1.53,6,.12,8.87c-2.29,4.56-6,8.22-9.7,11.74-3.36,3.2-6.85,6.41-11.1,8.27s-12.07,2.34-15.95-.2",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4,345.84a1,1,0,0,0,.2.18l.61.47,2.38,1.78,1.73,1.28c.62.48,1.27,1,2,1.61,1.4,1.17,3.06,2.44,4.73,4l2.68,2.44c.92.85,1.82,1.81,2.78,2.76,1.95,1.88,3.84,4.07,5.88,6.33a137.14,137.14,0,0,1,11.7,16,138,138,0,0,1,9.05,17.61c1.11,2.83,2.23,5.5,3,8.09.42,1.29.88,2.51,1.23,3.72l1,3.48c.67,2.21,1.06,4.26,1.48,6,.2.89.41,1.72.56,2.49s.26,1.48.37,2.11c.22,1.24.4,2.22.53,2.93l.15.76a.65.65,0,0,0,.07.25,1,1,0,0,0,0-.26c0-.2-.06-.46-.1-.77-.1-.71-.24-1.7-.43-2.94-.09-.64-.2-1.35-.32-2.13s-.33-1.6-.51-2.5c-.4-1.79-.76-3.86-1.41-6.07-.31-1.12-.62-2.29-1-3.51s-.79-2.45-1.21-3.74c-.79-2.6-1.89-5.29-3-8.14a133.12,133.12,0,0,0-9-17.7,132.47,132.47,0,0,0-11.79-16c-2-2.26-4-4.45-5.94-6.32-1-.95-1.87-1.91-2.81-2.75l-2.71-2.42c-1.69-1.57-3.37-2.82-4.8-4-.72-.56-1.38-1.11-2-1.58l-1.76-1.24-2.44-1.7-.64-.43C42.48,345.88,42.41,345.83,42.4,345.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.37,399.39a3.46,3.46,0,0,0,.78-.13c.51-.09,1.24-.28,2.21-.44a62.31,62.31,0,0,1,8.22-1,61.19,61.19,0,0,1,26.69,4.49,61.11,61.11,0,0,1,22,15.77,63,63,0,0,1,5.08,6.54c.56.8.94,1.46,1.24,1.88a7,7,0,0,0,.45.65,4,4,0,0,0-.36-.7c-.27-.45-.62-1.13-1.16-1.95a56.76,56.76,0,0,0-5-6.67,59.05,59.05,0,0,0-49-20.39,56,56,0,0,0-8.23,1.18c-1,.19-1.69.42-2.2.55S27.37,399.38,27.37,399.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.29,311.18a1.31,1.31,0,0,0,0,.3l.18.87c.17.8.42,1.91.74,3.33.66,2.88,1.65,7.05,2.91,12.19,2.5,10.28,6.13,24.44,9.92,40.13,1.88,7.86,3.58,15.36,5,22.19s2.67,13,3.58,18.24c.49,2.59.86,5,1.21,7s.63,3.86.84,5.32.4,2.56.53,3.37q.09.54.15.87a.94.94,0,0,0,.07.3,1.35,1.35,0,0,0,0-.3c0-.23-.06-.52-.1-.89L94,420.75c-.18-1.47-.43-3.26-.76-5.34s-.66-4.44-1.13-7.05c-.86-5.22-2-11.41-3.47-18.27s-3.13-14.35-5-22.21c-3.79-15.7-7.48-29.84-10.08-40.1-1.29-5.1-2.33-9.25-3.07-12.15-.35-1.41-.64-2.51-.84-3.3-.09-.36-.17-.64-.23-.86A1.65,1.65,0,0,0,69.29,311.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.36,423.76a1.21,1.21,0,0,0,.07-.23c0-.19.09-.42.16-.7.13-.65.32-1.55.56-2.69.48-2.33,1.11-5.72,1.84-9.93,1.46-8.4,3.18-20.08,4.24-33.06.52-6.49.8-12.69.93-18.33s0-10.73-.13-15c0-2.13-.2-4.06-.29-5.75s-.2-3.15-.31-4.34-.19-2.06-.26-2.73c0-.29,0-.52-.08-.71a.92.92,0,0,0,0-.24.87.87,0,0,0,0,.24c0,.2,0,.43,0,.72,0,.67.08,1.58.15,2.74s.16,2.64.22,4.34.18,3.61.21,5.74c.13,4.26.14,9.34,0,15s-.46,11.82-1,18.3c-1.06,13-2.72,24.63-4.08,33-.68,4.21-1.26,7.61-1.68,10-.19,1.14-.35,2-.46,2.7,0,.29-.08.52-.11.71A.62.62,0,0,0,95.36,423.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.52,426.22a4.9,4.9,0,0,0,.29-.67l.75-1.94.53-1.41c.23-.5.47-1.05.73-1.63s.54-1.21.83-1.88.68-1.33,1-2.05l1.16-2.26,1.38-2.37c.91-1.66,2.09-3.32,3.22-5.12A123.17,123.17,0,0,1,113,396a135.57,135.57,0,0,1,9.81-9.82c1.64-1.38,3.13-2.75,4.64-3.91l2.15-1.71,2-1.5c1.28-1,2.5-1.8,3.56-2.51s2-1.34,2.75-1.8l1.76-1.12a3.56,3.56,0,0,0,.6-.42,3.61,3.61,0,0,0-.65.33l-1.81,1c-.8.44-1.74,1-2.81,1.73s-2.32,1.49-3.62,2.45l-2.07,1.48-2.18,1.7c-1.52,1.14-3,2.51-4.68,3.88a128.52,128.52,0,0,0-9.89,9.83,115.43,115.43,0,0,0-8.55,11c-1.14,1.82-2.31,3.49-3.21,5.18l-1.36,2.4-1.13,2.28c-.35.73-.72,1.41-1,2.08s-.55,1.31-.8,1.9-.48,1.15-.69,1.66-.35,1-.5,1.43c-.27.81-.48,1.47-.65,2A3.45,3.45,0,0,0,94.52,426.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.61,368.25c0,.08,1.38.08,3.59.21a67.61,67.61,0,0,1,8.57,1,67.64,67.64,0,0,1,8.35,2.18,35.55,35.55,0,0,0,3.41,1.12,3.27,3.27,0,0,0-.85-.46c-.56-.27-1.39-.62-2.44-1A51.61,51.61,0,0,0,58.87,369a50.88,50.88,0,0,0-8.66-.89c-1.11,0-2,0-2.64.05A3.16,3.16,0,0,0,46.61,368.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.05,410.07A32.63,32.63,0,0,1,42.72,403c3.18-3.47,6.78-5,6.68-5.18a8.46,8.46,0,0,0-2.3,1,20.63,20.63,0,0,0-4.77,3.8,20.2,20.2,0,0,0-3.43,5A7.68,7.68,0,0,0,38.05,410.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.25,326.87c-.11.11,2,2.18,4.26,5s3.9,5.26,4,5.18a23,23,0,0,0-3.62-5.52A22.88,22.88,0,0,0,67.25,326.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.11,315a38.62,38.62,0,0,0-1.54,9.05,20.63,20.63,0,0,0,1-4.48A20.11,20.11,0,0,0,74.11,315Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.34,352.19a57.62,57.62,0,0,0,3.32,7,56.56,56.56,0,0,0,3.8,6.74,56.61,56.61,0,0,0-3.32-7A56.56,56.56,0,0,0,95.34,352.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,339.57a32,32,0,0,0-2.82,5.06,30.94,30.94,0,0,0-2.33,5.29,31.11,31.11,0,0,0,2.81-5.05A31,31,0,0,0,108,339.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.55,382.72c0,.15,2.29-.28,5.1-.48s5.11-.09,5.12-.24a14.49,14.49,0,0,0-5.15-.29A15,15,0,0,0,126.55,382.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.87,420.87l-6.32,33.23a4.66,4.66,0,0,1-4.58,3.79H84.31a4.66,4.66,0,0,1-4.6-3.89l-5.49-33.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.82 431.67 76.11 431.67 74.22 420.87 113.87 420.87 111.82 431.67",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.82 431.67 111.07 435.61 76.66 435.61 76.11 431.67 111.82 431.67",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.17,427.82l.79,19.36s-19.42,7.31-19.62,10.9l37.6-.18V427.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.58,445.5a1.54,1.54,0,0,1,1.07,1.75,1.49,1.49,0,0,1-1.73,1.07,1.61,1.61,0,0,1-1.12-1.85,1.52,1.52,0,0,1,1.92-.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.94,457.9l-.12-3-36,1.31s-1.67.74-1.48,1.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.35,447c0,.18.92.26,1.83.84s1.39,1.36,1.56,1.29-.11-1.14-1.22-1.83S387.31,446.83,387.35,447Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.41,448.64c0,.18.76.49,1.39,1.26s.81,1.6,1,1.59.29-1.05-.5-2S383.42,448.47,383.41,448.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.2,453.37c.16,0,.41-.88-.06-1.88s-1.34-1.4-1.42-1.24.46.68.84,1.51S381,453.36,381.2,453.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.66,442.56c.08.17.92-.09,2,0s1.84.39,1.94.23-.69-.81-1.91-.87S387.57,442.42,387.66,442.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,432.33l4.88,22.93-1.37,19.25a2.4,2.4,0,0,0,2.39,2.57h0a2.4,2.4,0,0,0,1.95-1c2.88-4,13.4-18.93,13-20.59-.53-1.92-3.54-24.53-3.54-24.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.89,477.08l14.6-23.15.19,1a3.58,3.58,0,0,1-.41,2.46c-1.14,2-4.4,7.44-12.36,18.7a2.4,2.4,0,0,1-2,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M459.36,447.39a1.46,1.46,0,0,0,0,1.94,1.4,1.4,0,0,0,1.93.06,1.54,1.54,0,0,0,0-2.06,1.46,1.46,0,0,0-2,.17",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M454.25,466a7.44,7.44,0,0,0-2.36-1.41,7.59,7.59,0,0,0-2.75,0c0-.05.23-.28.76-.46a3.78,3.78,0,0,1,2.13,0,3.82,3.82,0,0,1,1.82,1.12C454.2,465.66,454.3,466,454.25,466Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.19,469.41a20.94,20.94,0,0,0-2.23-.6,22.42,22.42,0,0,0-2.3.13,3.39,3.39,0,0,1,4.53.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.56,461.49a12.31,12.31,0,0,0-6.94-1.32,6.58,6.58,0,0,1,6.94,1.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.66,454.39c0,.15-1.41-.14-3.08.12s-2.9.89-3,.76a6,6,0,0,1,6.06-.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.4,447.63a11.49,11.49,0,0,0-3.21,0,11.83,11.83,0,0,0-2.91,1.34s.15-.38.62-.78a5.1,5.1,0,0,1,2.18-1.06,5.26,5.26,0,0,1,2.42,0C454.1,447.35,454.42,447.57,454.4,447.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451,446.36a2,2,0,0,1-.2-.86,6.26,6.26,0,0,1,.26-2.42,2.76,2.76,0,0,1,.91-1.49,1,1,0,0,1,1.11,0,1.54,1.54,0,0,1,.56,1,3.39,3.39,0,0,1-2.34,3.63,3.92,3.92,0,0,1-4.18-1.3,1.38,1.38,0,0,1-.28-1.11,1,1,0,0,1,.88-.67,3.3,3.3,0,0,1,1.67.5,7,7,0,0,1,1.91,1.49,2.22,2.22,0,0,1,.51.73,11.32,11.32,0,0,0-2.58-1.9,3.3,3.3,0,0,0-1.47-.4.51.51,0,0,0-.48.37.92.92,0,0,0,.23.71,3.5,3.5,0,0,0,3.64,1.09,3,3,0,0,0,2-3.06,1.11,1.11,0,0,0-.37-.69.51.51,0,0,0-.61,0,2.45,2.45,0,0,0-.79,1.25A9.24,9.24,0,0,0,451,446.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.33,270.37s-.16,10.2.52,23.37c.26,5.1,11,146.86,11,146.86l23.18.58-3.19-132.49,4,1s12.21,44.18,14.87,54.29c3.16,12,20.17,80.22,20.17,80.22l21.19.78-13.94-79.91L439.1,289l-2.41-22.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.84,295.29a4.77,4.77,0,0,1-1,.52,11.5,11.5,0,0,1-2.89.93,6,6,0,0,1-2.14,0,4.39,4.39,0,0,1-2.21-1.13,5.34,5.34,0,0,1-1.29-2.4c-.25-.91-.38-1.85-.55-2.8-.65-3.84-1.06-7.34-1.29-9.88-.11-1.27-.18-2.3-.22-3a5.29,5.29,0,0,1,0-1.11,4.48,4.48,0,0,1,.19,1.09c.1.81.23,1.81.38,3,.31,2.53.78,6,1.42,9.83.33,1.9.54,3.82,1.68,5a4.85,4.85,0,0,0,4,1.15,13.46,13.46,0,0,0,2.87-.77A4.72,4.72,0,0,1,408.84,295.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.31,277.16s.15-.11.48-.13a2.13,2.13,0,0,1,1.28.45,2.33,2.33,0,0,1,.94,1.82,2.31,2.31,0,0,1-4,1.37,2.34,2.34,0,0,1-.39-2,2,2,0,0,1,.74-1.15c.26-.2.44-.22.45-.2a2.63,2.63,0,0,0-.85,1.42,2,2,0,0,0,.4,1.64,1.74,1.74,0,0,0,1.91.41,1.72,1.72,0,0,0,1.24-1.5,2,2,0,0,0-.7-1.54A2.66,2.66,0,0,0,402.31,277.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.81,287.63a2.36,2.36,0,0,1-.79.11,16.48,16.48,0,0,1-2.18,0A21.18,21.18,0,0,1,423,281.9a14.68,14.68,0,0,1-1.46-1.62,2.85,2.85,0,0,1-.45-.66c.07-.05.79.82,2.15,2a24.07,24.07,0,0,0,5.9,3.83,23.73,23.73,0,0,0,6.78,1.89C437.68,287.58,438.81,287.54,438.81,287.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.68,277.1a12.32,12.32,0,0,1-.92,2.32,26.14,26.14,0,0,1-3,4.88,20.92,20.92,0,0,1-3.72,3.76,6.41,6.41,0,0,1-1.74,1.09,18.37,18.37,0,0,1,1.61-1.38,27.52,27.52,0,0,0,3.62-3.82,33.1,33.1,0,0,0,3-4.72C382.25,277.92,382.63,277.06,382.68,277.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,130.59a18,18,0,0,1,17.9-16.6h.93c10.05.56,15.19,9.41,14.35,19.44L427,164.62l-17.91,18.62-4.58-11.13,0-7.41s-9.66-1.48-9.81-11.13C394.68,148.9,395.32,139.28,396,130.59Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.48,164.69A23.48,23.48,0,0,0,417.13,161s-3,7-12.6,6.11Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.58,138.64a1.38,1.38,0,0,0,1.33,1.38,1.32,1.32,0,0,0,1.42-1.24,1.37,1.37,0,0,0-1.33-1.39A1.32,1.32,0,0,0,398.58,138.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.08,135.31c.18.18,1.22-.6,2.7-.6s2.58.74,2.74.56-.1-.41-.57-.75a3.72,3.72,0,0,0-2.19-.67,3.63,3.63,0,0,0-2.15.7C398.15,134.9,398,135.23,398.08,135.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,139a1.39,1.39,0,0,0,1.34,1.39,1.33,1.33,0,0,0,1.42-1.25,1.39,1.39,0,0,0-1.34-1.39A1.32,1.32,0,0,0,412,139Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.67,135.54c.18.18,1.22-.59,2.7-.59s2.58.73,2.74.55-.1-.4-.57-.75a3.8,3.8,0,0,0-2.19-.66,3.59,3.59,0,0,0-2.15.7C412.75,135.14,412.59,135.46,412.67,135.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.32,146.57a9.21,9.21,0,0,0-2.41-.43c-.38,0-.74-.12-.81-.37a2,2,0,0,1,.25-1.13l1.12-2.89c1.54-4.11,2.66-7.49,2.49-7.55s-1.55,3.22-3.1,7.33c-.37,1-.72,2-1.06,2.91a2.18,2.18,0,0,0-.19,1.49.94.94,0,0,0,.62.55,2.72,2.72,0,0,0,.64.09A9.91,9.91,0,0,0,407.32,146.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.69,147.58c-.24,0-.24,1.6-1.62,2.74s-3.09,1-3.1,1.21.38.31,1.11.32a3.92,3.92,0,0,0,2.59-.91,3.47,3.47,0,0,0,1.25-2.3C412,148,411.8,147.57,411.69,147.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.28,129.73c.14.4,1.62.2,3.37.41s3.15.68,3.38.31c.1-.17-.15-.55-.71-.94a5.9,5.9,0,0,0-5.15-.55C412.53,129.22,412.21,129.54,412.28,129.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.62,131c.26.34,1.28,0,2.51,0s2.27.22,2.51-.13c.11-.17-.06-.51-.52-.83a3.49,3.49,0,0,0-2-.54,3.44,3.44,0,0,0-2,.68C398.64,130.5,398.5,130.84,398.62,131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.42,122.14a1.84,1.84,0,0,1,1.89-1.54A4,4,0,0,1,393,120a1.36,1.36,0,0,1-.5-1.34c.23-.75,1.18-.93,1.93-1.17a4.91,4.91,0,0,0,2.47-1.75c.89-1.18,1.2-2.7,1.95-4a6.42,6.42,0,0,1,9.92-1.38,6.68,6.68,0,0,1,10.79,1.33,7.78,7.78,0,0,1,10.9,8.22l-5.9,3.85a3.25,3.25,0,0,0-4-2.7c-1.8.58-2.9,2.71-4.78,2.91-1.47.15-2.75-.95-4.18-1.29a7,7,0,0,0-5.07,1.25,20.32,20.32,0,0,1-4.69,2.54,10,10,0,0,1-6.15-.56,6.19,6.19,0,0,1-2.3-1.34A2.8,2.8,0,0,1,392.42,122.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.39,121l-27.54.63a12.69,12.69,0,0,1,4-4.69,21.51,21.51,0,0,1,12.46-4.49c4.49-.08,13.64,5.38,16.9,8.47,2.6,2.48,2.59,4.63,2.59,4.63.41,3.57-1.58,7.63-2.38,11.13-.4,1.81-1.19,7.28-1.19,7.28h0c-1.52,0-2.08-1.21-1.86-2.71l.28-5.89A8.88,8.88,0,0,1,424,124.94C424.37,124.4,425.21,122,423.39,121Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.12,134.91c1.27-4.92,2.4-10.18.78-15l.81-.06.35.24a3.85,3.85,0,0,1,4.5,5.81,3.34,3.34,0,0,1,3.43,2.82,6.23,6.23,0,0,1-.8,3.24,7.49,7.49,0,0,0-.95,3.21,2.41,2.41,0,0,0,1.9,2.44,2.76,2.76,0,0,1-3.08,1.6,5.55,5.55,0,0,0,2,2.33c-1.76,1.27-4.23.93-6.21,0a5.3,5.3,0,0,1-2.84-2.48A6.66,6.66,0,0,1,427.12,134.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.73,140.58c.17-.07,6.64-2,6.44,4.62s-6.78,5.05-6.79,4.86S427.73,140.58,427.73,140.58Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.89,147.62s.12.08.31.18a1.16,1.16,0,0,0,.86,0,2.88,2.88,0,0,0,1.39-2.52,3.82,3.82,0,0,0-.28-1.65,1.32,1.32,0,0,0-.83-.91.59.59,0,0,0-.69.29c-.1.19-.06.32-.09.33s-.14-.12-.08-.39a.7.7,0,0,1,.27-.4.82.82,0,0,1,.64-.15,1.61,1.61,0,0,1,1.17,1.06,3.83,3.83,0,0,1,.35,1.85,3,3,0,0,1-1.76,2.8,1.24,1.24,0,0,1-1-.2C428.9,147.78,428.87,147.63,428.89,147.62Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.42,134.91s.18-.25.1-.77a2.46,2.46,0,0,0-1.28-1.68,7.57,7.57,0,0,0-3-.64,3.7,3.7,0,0,1-3.05-1.45,5.45,5.45,0,0,1-.62-3.44c.13-1.11.39-2.13.51-3a4.87,4.87,0,0,0-.12-2.82,12.69,12.69,0,0,1-.23,2.76c-.17.85-.47,1.83-.63,3a5.78,5.78,0,0,0,.66,3.78,3.25,3.25,0,0,0,1.61,1.28,6.49,6.49,0,0,0,1.83.35,8,8,0,0,1,2.92.49,2.43,2.43,0,0,1,1.25,1.41A4,4,0,0,1,434.42,134.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.93,132s.14-.19.19-.6a3,3,0,0,0-1.19-2.6,3.36,3.36,0,0,0-1.28-.56,3.59,3.59,0,0,1-1.26-.48,1.5,1.5,0,0,1-.54-1.19c0-.5,0-1,0-1.56a7.54,7.54,0,0,0-1.22-3.82,1.83,1.83,0,0,0-1.49-.89c-.43,0-.61.22-.59.23s.22-.08.58,0a1.67,1.67,0,0,1,1.2.89,7.69,7.69,0,0,1,.85,2.23,7.07,7.07,0,0,1,.17,1.41c0,.48,0,1,0,1.57a2,2,0,0,0,.74,1.57,4.06,4.06,0,0,0,1.46.53,2.73,2.73,0,0,1,1.89,1.2A3.55,3.55,0,0,1,435.93,132Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.86,115.71s.5.34,1.36-.09a3.9,3.9,0,0,0,1.21-1.09,5.46,5.46,0,0,1,1.49-1.41,4.62,4.62,0,0,1,5,.19c.83.57,1.57,1.38,2.54,2a4.33,4.33,0,0,0,1.67.72,3.66,3.66,0,0,0,1.88-.24c1.17-.46,2.09-1.21,3.1-1.61a8.31,8.31,0,0,1,3.08-.65,8.18,8.18,0,0,1,5.05,1.58,8.92,8.92,0,0,1,2.43,2.69c.44.76.6,1.22.64,1.2s0-.12-.08-.35a6.3,6.3,0,0,0-.38-.94,8.5,8.5,0,0,0-2.4-2.89,8.4,8.4,0,0,0-5.26-1.76,8.7,8.7,0,0,0-3.27.65c-1.09.44-2,1.19-3.1,1.6a3,3,0,0,1-1.61.21,3.75,3.75,0,0,1-1.47-.63c-.9-.61-1.66-1.41-2.56-2a4.8,4.8,0,0,0-2.9-.87,5.13,5.13,0,0,0-2.54.76,5.39,5.39,0,0,0-1.52,1.54,3.92,3.92,0,0,1-1.09,1.1A1.93,1.93,0,0,1,396.86,115.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.16,203.23l-34.17-27-4.87-5.11s-11.64-10.87-12.62-12.06c-1.14-1.37-2.08-1.15-2.55-.7-.75.71-.5,2.15.44,3.35.33.42,5.72,6.79,5.72,6.79a20.33,20.33,0,0,0-2.68-.69c-1.95-.41-4.75.76-7,2.73s-2.67,2.73-1.94,3.63a1.47,1.47,0,0,0,1.16.49,2.92,2.92,0,0,0,1.95-.73c3.6-3.12,6.22-2,6.22-2l.64.67s-3.55.27-4.77,2.42a2.67,2.67,0,0,0-.34,1,3.74,3.74,0,0,0,1.08,6.35,1.56,1.56,0,0,0,1.75-.24,2.15,2.15,0,0,0,.32-.94,2.91,2.91,0,0,1,.12-.51l2.05,1.62s4.79,3.4,6.71,5.12L344,218.53a10.47,10.47,0,0,0,14.92.49h0A10.47,10.47,0,0,0,358.16,203.23Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.57,176.67a2.19,2.19,0,0,1-2.48.53c-.86-.29-1.59-.87-2.43-1.22-2.49-1.06-5.54,0-8-1.2-.35-.16-.71-.47-.63-.84s.5-.47.84-.53l8.83-1.69",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.72,171.72a3.6,3.6,0,0,0-1,.08c-.62.09-1.51.23-2.61.42l-3.88.69-1.11.2a1.8,1.8,0,0,0-1.24.55.75.75,0,0,0,0,.85,1.55,1.55,0,0,0,.56.47,6.41,6.41,0,0,0,1.25.44,35.52,35.52,0,0,0,4.83.32,6.69,6.69,0,0,1,2,.43,17.47,17.47,0,0,1,1.62.82,3.17,3.17,0,0,0,2.65.34c.63-.27.76-.67.74-.66a2.9,2.9,0,0,1-.8.47,3.05,3.05,0,0,1-2.42-.47,16.86,16.86,0,0,0-1.62-.89,6.74,6.74,0,0,0-2.1-.51,39.69,39.69,0,0,1-4.76-.35,5.79,5.79,0,0,1-1.13-.39c-.33-.17-.54-.45-.41-.6s.52-.27.9-.34l1.11-.22,3.85-.79c1.1-.24,2-.43,2.59-.58A4.23,4.23,0,0,0,318.72,171.72Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.59,172.57a3.85,3.85,0,0,0-1.45-.88,2.89,2.89,0,0,0-1.79.12,7.53,7.53,0,0,0-1.94,1.19,11.54,11.54,0,0,1-1.94,1.35,3.7,3.7,0,0,1-1.91.45,1.48,1.48,0,0,1-1.15-.64.84.84,0,0,1-.17-.46s.09.15.27.38a1.41,1.41,0,0,0,1.07.49,3.62,3.62,0,0,0,1.75-.49,12.72,12.72,0,0,0,1.88-1.34,7.46,7.46,0,0,1,2-1.22,3,3,0,0,1,2-.05,2.72,2.72,0,0,1,1.11.7C308.54,172.41,308.61,172.56,308.59,172.57Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,161.24a9.31,9.31,0,0,1,1.08,1.26l2.52,3.1,2.57,3.06a10.41,10.41,0,0,1,1,1.3,7.73,7.73,0,0,1-1.21-1.14c-.71-.75-1.65-1.8-2.65-3s-1.86-2.33-2.46-3.17A7.1,7.1,0,0,1,304,161.24Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.35,175.23a2.36,2.36,0,0,1-.49.16,1.56,1.56,0,0,0-1,.78.84.84,0,0,0,.11.81,4.89,4.89,0,0,0,.75.77,1.9,1.9,0,0,1,.69,1.14,1.61,1.61,0,0,1-.56,1.32,1.78,1.78,0,0,1-1.36.4,2.23,2.23,0,0,1-1.22-.5,7.34,7.34,0,0,1-1.34-1.66,4.53,4.53,0,0,1-.56-1.33c-.06-.34,0-.53,0-.53s0,.19.12.5a4.76,4.76,0,0,0,.63,1.23,7.63,7.63,0,0,0,1.33,1.56,1.78,1.78,0,0,0,2.17.08,1.25,1.25,0,0,0,.45-1,1.54,1.54,0,0,0-.57-.94,4.48,4.48,0,0,1-.77-.86,1.05,1.05,0,0,1-.09-1.05,1.58,1.58,0,0,1,1.2-.8A1.35,1.35,0,0,1,308.35,175.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.4,180.33s.16.09.27.39a1.47,1.47,0,0,1-.2,1.28,1.93,1.93,0,0,1-1.77.73,3.15,3.15,0,0,1-2-1.16,3.86,3.86,0,0,1-.88-2.17,3.65,3.65,0,0,1,1.15-2.9c.23-.2.38-.28.39-.26a5.8,5.8,0,0,0-.95,1.38,3.6,3.6,0,0,0,.54,3.73,2.94,2.94,0,0,0,1.82,1.08,1.72,1.72,0,0,0,1.54-.57,1.38,1.38,0,0,0,.26-1.11C306.48,180.48,306.38,180.34,306.4,180.33Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.39,180.94s.17-.26.62-.51a3.2,3.2,0,0,1,2-.3l-.17.24a10.81,10.81,0,0,1-.57-1,7,7,0,0,1-.9-3.78,18,18,0,0,0,1.2,3.63c.17.34.36.66.54.95l.2.32-.36-.08a3.32,3.32,0,0,0-1.87.17C314.65,180.79,314.42,181,314.39,180.94Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.17,170.12c.09,0,.23.64-.14,1.35s-1,1-1,.92.4-.44.71-1.07S305.08,170.12,305.17,170.12Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.61,221.19l19.73-13.66s-1.73,52.9-1.73,53.39c0,0-3.61,1.43-3,5.21l1,5.33c21.73,5,43.26,8.23,65.17.16l2.49-42.14L448,178l-17.63-7.5-3-7-18.26,19.67-4.67-12.7.13-4.79-4.42,4.8L378.75,174l-26.66,21.61-8.74-7.07-13.19,18.32,15,15.14A17.5,17.5,0,0,0,356.61,221.19Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.43,180.84a3,3,0,0,0-1.28,1.43,5.63,5.63,0,0,0-.39,2.18,8.13,8.13,0,0,1-.42,3l-.22.52-.22-.52a29,29,0,0,1-1.4-4.58c-.75-3.24-1.23-6.21-1.56-8.36a21.28,21.28,0,0,1-.37-3.5,27.65,27.65,0,0,1,.74,3.44c.41,2.13.95,5.08,1.7,8.3a31.43,31.43,0,0,0,1.33,4.51h-.44a8.45,8.45,0,0,0,.46-2.79,5.51,5.51,0,0,1,.53-2.28,2.48,2.48,0,0,1,1-1.14C406.23,180.83,406.42,180.82,406.43,180.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.38,172.93a4,4,0,0,1-.6.87c-.42.54-1,1.31-1.8,2.25-1.54,1.88-3.68,4.45-6.08,7.27l-3.82,4.46-.29.34-.11-.44c-.55-2.17-1-4-1.28-5.3-.12-.64-.48-1-.83-1a.76.76,0,0,0-.48.14s.07-.26.48-.29a.92.92,0,0,1,.66.27,2,2,0,0,1,.44.83c.37,1.28.88,3.09,1.46,5.26l-.4-.1L420.5,183c2.4-2.82,4.59-5.35,6.2-7.17.8-.91,1.46-1.64,1.92-2.14A4.42,4.42,0,0,1,429.38,172.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,255.74a2.83,2.83,0,0,1-.05-.68c0-.49,0-1.13,0-1.92,0-1.67,0-4.09,0-7.08.07-6,.35-14.23,1-23.32s1.63-17.31,2.45-23.23c.41-3,.77-5.35,1.05-7l.32-1.89a6.77,6.77,0,0,1,.15-.66,2.61,2.61,0,0,1,0,.67c-.06.49-.14,1.13-.23,1.91-.22,1.72-.52,4.1-.89,7-.72,5.93-1.61,14.13-2.29,23.22s-1,17.32-1.19,23.29c-.07,2.94-.12,5.34-.16,7.07q0,1.19-.06,1.92A5.33,5.33,0,0,1,403,255.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,267.88a11.63,11.63,0,0,1-.46-4.44A16.14,16.14,0,0,1,398,259a23.35,23.35,0,0,1,0,4.45C397.94,265.89,398.1,267.86,398,267.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.36,253.33a9.65,9.65,0,0,1-1.59.6c-1,.36-2.56.84-4.44,1.39a146.38,146.38,0,0,1-14.94,3.47,149.51,149.51,0,0,1-15.21,1.89c-2,.13-3.55.21-4.65.23a10.2,10.2,0,0,1-1.7,0,10.31,10.31,0,0,1,1.69-.19l4.63-.39c3.89-.36,9.27-1,15.15-2S413.45,256,417.23,255l4.48-1.22A12.44,12.44,0,0,1,423.36,253.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.28,219.65c-.14,0-.23-7.36-.2-16.43s.18-16.43.32-16.43.23,7.36.2,16.43S376.43,219.65,376.28,219.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M410.81,184.94a2.4,2.4,0,0,1,2.4,1.76c.2,1.07.05,2.2.33,3.26s1.25,2.09,2.32,1.87a2.84,2.84,0,0,0,1.53-1.21,37.16,37.16,0,0,0,5-9.29c0,.08-5.54,6.36-5.54,6.36a18,18,0,0,0-1.24-4.62c-.18-.48-.4-1.3-.86-1.51-.75-.35-1.75.75-2.25,1.42a12.43,12.43,0,0,1-1.73,1.86"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M401.78,179.23a32.17,32.17,0,0,0,2,10.29,2.2,2.2,0,0,0,.54.89.83.83,0,0,0,1,.15,11.83,11.83,0,0,0,1-2.13c.51-1.43,2.59-1.56,2.59-1.56a37.18,37.18,0,0,0-1.36-4.76,1.31,1.31,0,0,0-1.29-.83,2.13,2.13,0,0,0-1.42,1.63c-.31,2.56-.27,3.74-.65,4.64-1-2.74-1.76-6-2.4-8.41"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M417.12,255a2.19,2.19,0,0,0,.48-3.09,3.34,3.34,0,0,0-3.13-1.18,7,7,0,0,0-3.16,1.42c-.95.69-1.82,1.47-2.82,2.08-2.45,1.51-5.43,1.85-8.31,1.9a50.44,50.44,0,0,0-8.61.38c-2.82.55-5.64,2-7,4.54C384.56,261,409.15,259.25,417.12,255Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M448,178s7.44,5.3,9.24,10.1,8.45,37.77,9.53,43.4c1.37,7.08,1.41,15.84-8.78,19.17-3.79,1.23-27-.66-27-.66l.76-16.49,12.53.47s-.75-1.11,1.05-2.45l-4-21.45s1.47-22.78,1.65-23.32S448,178,448,178Z",
    style: {
      fill: "#6C63FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.4,178.57a17,17,0,0,0-9.54,10,5.61,5.61,0,0,1,.54-2,13.84,13.84,0,0,1,7-7.31A5.92,5.92,0,0,1,448.4,178.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.46,237.33c-.08,0-.25-.55-.75-1.32a8.54,8.54,0,0,0-2.55-2.49,8.37,8.37,0,0,0-3.31-1.31c-.91-.13-1.49,0-1.51-.11a2.57,2.57,0,0,1,1.55-.25,7.37,7.37,0,0,1,3.56,1.23,7.53,7.53,0,0,1,2.58,2.74A2.72,2.72,0,0,1,452.46,237.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,197.06a7.65,7.65,0,0,1,.34,1.32c.21,1,.46,2.19.77,3.65.62,3.09,1.44,7.36,2.31,12.08s1.64,9,2.17,12.11c.24,1.48.44,2.71.59,3.68a6.51,6.51,0,0,1,.15,1.36,8.11,8.11,0,0,1-.35-1.32c-.2-1-.45-2.19-.76-3.65-.62-3.09-1.44-7.36-2.31-12.08s-1.64-9-2.17-12.11c-.24-1.48-.44-2.71-.59-3.68A6.51,6.51,0,0,1,439,197.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,250a7,7,0,0,1,0-1.28c0-.91,0-2.08.08-3.49.09-3,.24-7.09.45-11.74v-.25h.26l2.06.08,10.46.45h.07l.05.05a11.14,11.14,0,0,1,3.43,4.82,10.68,10.68,0,0,1,.43,1.6,1.82,1.82,0,0,1,.05.58c-.06,0-.18-.79-.71-2.09a11.37,11.37,0,0,0-3.47-4.58l.13.05-10.46-.36-2.06-.09.26-.24c-.21,4.64-.43,8.77-.61,11.72-.1,1.41-.18,2.58-.24,3.49A5.81,5.81,0,0,1,431,250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.69,230.06,403,210.28a3.92,3.92,0,0,0-3.52-2.19H375.07a1.19,1.19,0,0,0-1.05,1.76l16.5,30.82a2.68,2.68,0,0,0,2.35,1.4h25.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.18,210l.49,0,1.39,0h5.14l16.93-.14a4.79,4.79,0,0,1,2.25.54,4.22,4.22,0,0,1,1.5,1.66c.71,1.35,1.3,2.76,1.92,4l3.24,6.9,2.21,4.63c.25.51.46.92.63,1.25a1.92,1.92,0,0,0,.24.42,1.75,1.75,0,0,0-.16-.46c-.14-.34-.33-.76-.55-1.28-.51-1.17-1.22-2.76-2.08-4.7s-2-4.34-3.15-6.93c-.61-1.31-1.18-2.68-1.91-4.09a4.62,4.62,0,0,0-1.66-1.83,5.18,5.18,0,0,0-2.46-.61c-6.64,0-12.61.19-17,.28l-5.13.14-1.4.06A1.58,1.58,0,0,0,374.18,210Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.21,214.33a.8.8,0,0,0-.37,1.22,1.16,1.16,0,0,0,1.29.49.89.89,0,0,0,.67-.65,1.11,1.11,0,0,0-.74-1.12A1.77,1.77,0,0,0,389.21,214.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.49,234.19l-6.06-.59s-2.75-3.12-3.83-4.06-7.26-4-7.26-4-3.21-3.41-3.63-3.36-1.74.46-1.17,2.15a26.17,26.17,0,0,0,2.12,4.84l-12.21,1.74a2.61,2.61,0,0,0-1.88,1.19c-.27.45-.35.92.26,1.13a58.59,58.59,0,0,0,6.7,1.14l-2.4-.32s-.23,2.28,1.37,3.16a7.53,7.53,0,0,1,1.71,1.06,7.1,7.1,0,0,0,1.06,2.86c.74.77,8.06,3.49,8.06,3.49s4.57.78,6.78.4l9.9,1.51Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.48,229.39a25.34,25.34,0,0,0,3.49,0,13.13,13.13,0,0,0,3.48-.25,15,15,0,0,0-3.49-.19A9.8,9.8,0,0,0,410.48,229.39Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.77,234.62a18.61,18.61,0,0,0-5.13-.46c-1.42,0-2.7,0-3.63,0a6.87,6.87,0,0,0-1.5.06,4,4,0,0,0,1.49.24c.94.07,2.22.1,3.64.11C410.47,234.58,412.75,234.73,412.77,234.62Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.25,238.63c0-.13-1.8,0-4-.09s-4-.44-4-.31a11.06,11.06,0,0,0,4,.75A10.72,10.72,0,0,0,413.25,238.63Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.05,243.2c.12,0,.24-.49.27-1.12s-.05-1.13-.17-1.14-.24.5-.27,1.12S412.93,243.2,413.05,243.2Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.5,237.7c.12,0,.14-.43.3-.88s.39-.77.31-.87-.53.16-.72.73S413.39,237.73,413.5,237.7Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.25,232.15c.13,0,.22-.27.33-.58s.21-.58.12-.66-.39.12-.53.51S414.13,232.16,414.25,232.15Z",
    style: {
      fill: "#eb996e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtasksPana);
export default __webpack_public_path__ + "static/media/Add tasks-pana.058ba19f19f01d6b797d75d8c8129c37.svg";
export { ForwardRef as ReactComponent };